import { z } from "zod";
import { roleKeySchema } from "./organization.js";
export const WHATSAPP_PROVIDERS = ["baileys", "meta"];
export const metaWhatsAppConfigSchema = z.object({
    enabled: z.boolean().default(false),
    phoneNumberId: z.string().trim().default(""),
    wabaId: z.string().trim().default(""),
    accessToken: z.string().trim().default(""),
    apiVersion: z.string().trim().default("v21.0"),
});
export const updateMetaWhatsAppConfigSchema = z.object({
    activeProvider: z.enum(WHATSAPP_PROVIDERS).optional(),
    enabled: z.boolean().optional(),
    phoneNumberId: z.string().trim().optional(),
    wabaId: z.string().trim().optional(),
    accessToken: z.string().trim().optional(),
    clearAccessToken: z.boolean().optional(),
    apiVersion: z.string().trim().optional(),
});
export const testMetaConfigSchema = z.object({
    phoneNumberId: z.string().trim().min(1, "Phone Number ID is required"),
    accessToken: z.string().trim().optional(),
    apiVersion: z.string().trim().default("v21.0"),
});
/* ── Broadcast (promotional messages) ────────────────────────────────── */
export const BROADCAST_STATUSES = ["queued", "sending", "completed"];
/** `all` and legacy aliases are UI/API conveniences; role keys follow the org's configured tiers. */
export const BROADCAST_AUDIENCES = ["all", "karigar", "counter"];
export const broadcastAudienceSchema = z.union([z.enum(BROADCAST_AUDIENCES), roleKeySchema]);
export const broadcastTargetSchema = z.object({
    // Accept scalar values from older saved broadcasts while sending new arrays.
    city: z.preprocess((value) => typeof value === "string" ? (value ? [value] : []) : value, z.array(z.string().trim().min(1).max(100)).max(500).optional().default([])),
    area: z.preprocess((value) => typeof value === "string" ? (value ? [value] : []) : value, z.array(z.string().trim().min(1).max(100)).max(500).optional().default([])),
    district: z.preprocess((value) => typeof value === "string" ? (value ? [value] : []) : value, z.array(z.string().trim().min(1).max(100)).max(500).optional().default([])),
    state: z.preprocess((value) => typeof value === "string" ? (value ? [value] : []) : value, z.array(z.string().trim().min(1).max(100)).max(500).optional().default([])),
    pincode: z.preprocess((value) => typeof value === "string" ? (value ? [value] : []) : value, z.array(z.string().trim().min(1).max(12)).max(500).optional().default([])),
    counterIds: z.array(z.string().regex(/^[a-f\d]{24}$/i, "Invalid counter id.")).max(500).optional().default([]),
    karigarIds: z.array(z.string().regex(/^[a-f\d]{24}$/i, "Invalid karigar id.")).max(500).optional().default([]),
    recipientMode: z.enum(["all", "selected"]).optional().default("all"),
    recipientIds: z.array(z.string().regex(/^[a-f\d]{24}$/i, "Invalid recipient id.")).max(500).optional().default([]),
});
const broadcastAudienceListSchema = z.preprocess((value) => typeof value === "string" ? value.split(",").filter(Boolean) : value, z.array(broadcastAudienceSchema).min(1));
export const createBroadcastSchema = z.object({
    audiences: broadcastAudienceListSchema,
    target: broadcastTargetSchema.optional(),
    message: z.string().trim().min(1, "Message is required.").max(4000, "Message is too long (max 4000 characters)."),
    imageUrl: z.string().url().optional().or(z.literal("")),
    imageDataUrl: z.string().max(7_100_000).regex(/^data:image\/(?:png|jpeg|webp|gif);base64,[A-Za-z0-9+/=]+$/i, "Choose a valid image.").optional(),
});
export const broadcastQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(50).default(20),
});
//# sourceMappingURL=whatsapp.js.map